import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user_id: null,
  balance: 0,
  holdings: {},
  transactions: [],
  portfolioValue: 0,
  profitOrLoss: 0,
  initialDeposit: 0,
};

const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    createAccount: (state) => {
      state.user_id = Math.random().toString(36).substr(2, 9);
      state.balance = 0;
      state.holdings = {};
      state.transactions = [];
      state.portfolioValue = 0;
      state.profitOrLoss = 0;
      state.initialDeposit = 0;
    },
    deposit: (state, action) => {
      state.balance += action.payload;
      state.initialDeposit += action.payload;
      state.transactions.push({ type: 'deposit', amount: action.payload });
    },
    withdraw: (state, action) => {
      if (state.balance >= action.payload) {
        state.balance -= action.payload;
        state.transactions.push({ type: 'withdraw', amount: action.payload });
      }
    },
    buyShares: (state, action) => {
      const { symbol, quantity } = action.payload;
      const price = getSharePrice(symbol);
      const totalCost = price * quantity;
      if (state.balance >= totalCost) {
        state.balance -= totalCost;
        if (state.holdings[symbol]) {
          state.holdings[symbol] += quantity;
        } else {
          state.holdings[symbol] = quantity;
        }
        state.transactions.push({ type: 'buy', symbol, quantity });
      }
    },
    sellShares: (state, action) => {
      const { symbol, quantity } = action.payload;
      const price = getSharePrice(symbol);
      if (state.holdings[symbol] && state.holdings[symbol] >= quantity) {
        state.holdings[symbol] -= quantity;
        state.balance += price * quantity;
        state.transactions.push({ type: 'sell', symbol, quantity });
      }
    },
    updatePortfolioValue: (state) => {
      state.portfolioValue = Object.entries(state.holdings).reduce((total, [symbol, shares]) => total + shares * getSharePrice(symbol), 0);
    },
    updateProfitOrLoss: (state) => {
      state.profitOrLoss = state.portfolioValue + state.balance - state.initialDeposit;
    },
  },
});

// Placeholder for getSharePrice function
function getSharePrice(symbol) {
  const prices = {
    AAPL: 150,
    TSLA: 700,
    GOOGL: 2800,
  };
  return prices[symbol] || 0;
}

export const { createAccount, deposit, withdraw, buyShares, sellShares, updatePortfolioValue, updateProfitOrLoss } = accountSlice.actions;

export default accountSlice.reducer;
